import PropTypes from 'prop-types';
import React from 'react';

const MessageText = (props) => {
  return (
    <div
      className="message-line"
      id={props.html_id}
      data-testid={props.data_test}
      data-aut-test={props.data_aut_test}
    >
      <div className="message-receive" id={`msg-${props.id}`}>
        <div className="message-div" data-aut-test="message-receive-text">
          {props.text}
        </div>
      </div>
    </div>
  );
};

MessageText.propTypes = {
  id: PropTypes.number,
  text: PropTypes.string,
  html_id: PropTypes.string,
  data_test: PropTypes.string,
  data_aut_test: PropTypes.string
};

export default MessageText;
